import type { StatementListField } from "@/types/template";

interface StatementItem {
  text: string;
  checked: boolean;
}

interface Props {
  field: StatementListField;
  value: StatementItem[];
  onChange: (value: StatementItem[]) => void;
}

export function StatementListInput({ onChange, value }: Readonly<Props>) {
  const toggle = (index: number) => {
    const next = value.map((item, i) => (i === index ? { ...item, checked: !item.checked } : item));
    onChange(next);
  };

  const updateText = (index: number, text: string) => {
    const next = value.map((item, i) => (i === index ? { ...item, text } : item));
    onChange(next);
  };

  const addItem = () => {
    onChange([...value, { checked: true, text: "" }]);
  };

  return (
    <>
      <div className="statement-list-items">
        {value.map((item, i) => (
          <div key={i} className="statement-list-item">
            <input
              type="checkbox"
              checked={item.checked}
              onChange={() => {
                toggle(i);
              }}
            />
            <textarea
              className="statement-list-textarea"
              value={item.text}
              onChange={(e) => {
                updateText(i, e.target.value);
              }}
              placeholder="Enter statement..."
              rows={1}
            />
          </div>
        ))}
      </div>
      <button className="statement-list-add" onClick={addItem}>
        + Add statement
      </button>
    </>
  );
}
